import { useEffect, useState } from "react";
import {
  useListContext,
  useGetOne,
  useRedirect,
  FilterForm,
  SearchInput,
} from "react-admin";
import { Stack, IconButton, Button, Paper } from "@mui/material";
import { KeyboardArrowLeft } from "@mui/icons-material";

const activeStyle = {
  backgroundColor: "#FEDA3B",
  color: "#000",
  "&:hover": {
    backgroundColor: "#FEDA3B",
    color: "#000",
  },
};

const ToolBar = () => {
  const redirect = useRedirect();
  const [value, setValue] = useState("All tyres");
  const { data } = useGetOne("garage", { id: localStorage.getItem("carId") });
  const { setFilters } = useListContext();

  const handleFilter = (event) => {
    setValue(event.target?.id);
    if (event.target?.id === "All") setFilters([], {});
    else {
      setFilters({ name: event.target?.id });
    }
  };

  useEffect(() => {
    setFilters([], {});
    setValue("All");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Stack mb={4}>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={{ xs: 1, sm: 2, md: 4 }}
        justifyContent="space-between"
        alignItems="center"
      >
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={{ xs: 1, sm: 2, md: 2 }}
          alignItems="center"
        >
          <IconButton onClick={() => redirect(`/garage/${data?.id}/show`)}>
            <KeyboardArrowLeft fontSize="large" />
          </IconButton>

          <Stack>
            <span style={{ color: "#FEDA3B", fontSize: "12px" }}>
              {`Garage / ${data?.brand}`}
            </span>
            <span
              style={{
                fontSize: "25px",
                fontWeight: "bold",
                margin: "10px 0",
              }}
            >
              Tyres Diary
            </span>
          </Stack>
        </Stack>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          alignItems="center"
          spacing={{ xs: 1, sm: 2, md: 4 }}
        >
          <Paper
            sx={{
              width: "auto",
              height: "30px",
              padding: "5px",
            }}
          >
            <Stack
              justifyContent="center"
              alignItems="center"
              spacing={1}
              direction="row"
            >
              <Button
                variant="text"
                id="All"
                onClick={handleFilter}
                sx={value === "All" ? activeStyle : {}}
              >
                ALL
              </Button>
              <Button
                variant="text"
                id="Slick Pirelli"
                onClick={handleFilter}
                sx={value === "Slick Pirelli" ? activeStyle : {}}
              >
                SLICK PIRELLI
              </Button>
              <Button
                variant="text"
                id="Slick Hankook"
                onClick={handleFilter}
                sx={value === "Slick Hankook" ? activeStyle : {}}
              >
                SLICK HANKOOK
              </Button>
              <Button
                variant="text"
                id="Wet Pirelli"
                onClick={handleFilter}
                sx={value === "Wet Pirelli" ? activeStyle : {}}
              >
                WET PIRELLI
              </Button>
              <Button
                variant="text"
                id="Wet Hankook"
                onClick={handleFilter}
                sx={value === "Wet Hankook" ? activeStyle : {}}
              >
                WET HANKOOK
              </Button>
            </Stack>
          </Paper>
          <FilterForm
            sx={{
              alignItems: "center",
              "& .RaFilterFormInput-spacer": {
                display: "none",
              },
            }}
            filters={[
              <SearchInput
                InputLabelProps={{ shrink: true }}
                size="small"
                color="secondary"
                variant="filled"
                source="q"
                alwaysOn
                placeholder="Search"
                sx={{
                  "&.MuiTextField-root": {
                    backgroundColor: "#fff",
                    borderRadius: "4px",
                    border: "1px solid #fff",
                    width: "200px",
                  },
                  "& .MuiSvgIcon-root": {
                    color: "#BDC8D1",
                  },
                  input: {
                    color: "#000",
                    "&:-webkit-autofill": {
                      WebkitBoxShadow: "0 0 0 100px #fff inset",
                      WebkitTextFillColor: "#000",
                    },
                  },
                }}
              />,
            ]}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default ToolBar;
